// Job: Starts browser Sentry when VITE_SENTRY_DSN is set and re-exports the SDK.
// Why: Errors on the web side reach Sentry (CLAUDE.md); dev and tests run without a DSN, so it stays off there.
import * as Sentry from '@sentry/react';

export function initSentry() {
  const dsn = import.meta.env.VITE_SENTRY_DSN as string | undefined;
  if (!dsn) return;
  Sentry.init({
    dsn,
    environment: import.meta.env.MODE,
    tracesSampleRate: 0.1,
  });
}

export { Sentry };
